import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Checkbox from '@mui/material/Checkbox';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import {
  Avatar,
  Card,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputBase,
  Popover,
  Tooltip,
  useMediaQuery,
} from '@mui/material';
import {
  Box,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { makeStyles, styled, useTheme } from '@mui/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { TabPanel } from 'component/OwnerCard/OwnerCard';
import {
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { ReactComponent as FeedbackProfile } from 'assets/icons/feedback-profile.svg';
import { FeedbackDocumentation } from '../TaskPageNoteandFeedback/FeedbackDocumentation';
import { Stack } from '@mui/system';
import TemplateText from 'component/PropertyDetails/TemplateText';
import { addNote, getNotes, getApiCall, postApiCall } from 'api/apiService';
import Swal from 'sweetalert2';
import {
  PROPERTYLIST_COMMON,
  USER_STORETASK,
  USER_UPDATETASK,
} from 'constant/app.config';
import {
  LocalizationProvider,
  StaticDateTimePicker,
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { getMoxoAcions } from 'api/rcpapiService';
import { CloseIcon } from 'component/Chart/ModelGraphExpandIcons';
import { Contact } from 'component/BuyerRegistration/BuyerRegistration.util';
import Loading from 'assets/images/loading.png';

const LocationIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
        fill="#112347"
      />
    </svg>
  );
};
const Chat = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.1592 15.9274C14.7294 15.9274 14.3801 15.5782 14.3801 15.1484C14.3801 14.7198 14.7294 14.3706 15.1592 14.3706C15.589 14.3706 15.9382 14.7198 15.9382 15.1484C15.9382 15.5782 15.589 15.9274 15.1592 15.9274ZM12.1306 15.9274C11.7008 15.9274 11.3516 15.5782 11.3516 15.1484C11.3516 14.7198 11.7008 14.3706 12.1306 14.3706C12.5605 14.3706 12.9097 14.7198 12.9097 15.1484C12.9097 15.5782 12.5605 15.9274 12.1306 15.9274ZM17.4088 15.1484C17.4088 15.5782 17.758 15.9274 18.1878 15.9274C18.6177 15.9274 18.9669 15.5782 18.9669 15.1484C18.9669 14.7198 18.6177 14.3706 18.1878 14.3706C17.758 14.3706 17.4088 14.7198 17.4088 15.1484Z"
        fill="#6C2AD2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.012 8.3335C11.1387 8.3335 8.33203 11.4976 8.33203 15.0102C8.33203 16.1319 8.6587 17.2863 9.23203 18.3412C9.3387 18.5154 9.35203 18.7351 9.2787 18.9427L8.83203 20.4383C8.73203 20.7989 9.0387 21.0653 9.3787 20.9584L10.7254 20.5585C11.092 20.4383 11.3787 20.5912 11.7187 20.7989C12.692 21.3724 13.9054 21.6668 14.9987 21.6668C18.3054 21.6668 21.6654 19.1097 21.6654 14.9901C21.6654 11.4375 18.7987 8.3335 15.012 8.3335Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
    </svg>
  );
};
const Phone = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.5"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6164 11.6322C10.7873 11.3492 11.7287 10.3202 12.4005 10.3513C12.6014 10.3679 12.7789 10.4894 12.9231 10.6303C13.2543 10.9537 14.2024 12.1769 14.2562 12.4343C14.3871 13.0656 13.6349 13.4295 13.8651 14.0658C14.452 15.502 15.4634 16.5132 16.9002 17.0996C17.5359 17.3298 17.8999 16.5776 18.5312 16.7091C18.788 16.7629 20.0118 17.7109 20.3353 18.0421C20.4756 18.1858 20.5977 18.3638 20.6143 18.5646C20.6393 19.2719 19.5464 20.2266 19.3334 20.3487C18.8308 20.7081 18.175 20.702 17.3756 20.3303C15.1449 19.4023 11.58 15.9047 10.6347 13.5898C10.273 12.7949 10.2481 12.1347 10.6164 11.6322Z"
        stroke="#6C2AD2"
        stroke-width="0.81025"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const Location = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.0214 1.66606C6.18054 1.65301 3.04331 4.70881 2.91792 8.53381L2.91406 8.77123C2.9779 10.6461 3.61579 12.4333 4.7393 13.9057L5.00316 14.25C6.07556 15.6136 7.34999 16.8105 8.78096 17.7969L9.12549 18.0289L9.17577 18.0683C9.66623 18.4207 10.3284 18.4207 10.8189 18.0683L10.8607 18.034C11.9962 17.2976 13.0432 16.4324 13.9811 15.4554C15.8879 13.437 17.0372 11.1754 17.0805 8.8785L17.0806 8.79322C17.0937 4.94262 14.0473 1.79574 10.234 1.66992L10.0214 1.66606ZM10.0161 2.93046C13.1648 2.94123 15.7213 5.45709 15.8163 8.59017L15.819 8.86642C15.7825 10.7921 14.7742 12.7763 13.0685 14.5819C12.1988 15.4878 11.2236 16.2931 10.166 16.9779L10.0955 17.0309C10.0385 17.0804 9.95403 17.0804 9.89707 17.0309L9.82856 16.9792C8.25298 15.9505 6.87014 14.6518 5.7433 13.1423C4.83565 11.9527 4.2978 10.5304 4.18954 9.04665L4.17363 8.74913C4.18433 5.59275 6.69244 3.02839 9.81588 2.93317L10.0161 2.93046ZM9.99821 6.16733C8.50788 6.16733 7.29974 7.37921 7.29974 8.87414C7.29974 10.3691 8.50788 11.5809 9.99821 11.5809C11.4885 11.5809 12.6967 10.3691 12.6967 8.87414C12.6967 7.37921 11.4885 6.16733 9.99821 6.16733ZM9.99715 7.43178C10.7913 7.43178 11.435 8.07751 11.435 8.87406C11.435 9.67062 10.7913 10.3163 9.99715 10.3163C9.20305 10.3163 8.5593 9.67062 8.5593 8.87406C8.5593 8.07751 9.20305 7.43178 9.99715 7.43178Z"
        fill="#112347"
      />
    </svg>
  );
};
const ArrowDown = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.03091 12.2803C7.98982 12.2403 7.81416 12.0892 7.66966 11.9484C6.76086 11.1231 5.27336 8.97015 4.81932 7.8433C4.74636 7.67217 4.59195 7.23951 4.58203 7.00834C4.58203 6.78684 4.63303 6.57568 4.73645 6.37419C4.88095 6.12301 5.10832 5.92152 5.37678 5.81111C5.56307 5.74004 6.12053 5.62963 6.13045 5.62963C6.74032 5.51922 7.73128 5.4585 8.82636 5.4585C9.86974 5.4585 10.8203 5.51922 11.4394 5.60962C11.4493 5.61997 12.1421 5.73037 12.3794 5.85113C12.8129 6.07264 13.082 6.5053 13.082 6.96832V7.00834C13.0714 7.30989 12.8022 7.94405 12.7923 7.94405C12.3376 9.01017 10.923 11.1134 9.98307 11.9587C9.98307 11.9587 9.74153 12.1968 9.59066 12.3003C9.37391 12.4618 9.10545 12.5418 8.83699 12.5418C8.53736 12.5418 8.25828 12.4514 8.03091 12.2803Z"
        fill="#112347"
      />
    </svg>
  );
};

const RightArrow = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M14.1133 8.375L20.2061 14.4678L14.1133 20.5605"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const Notetask = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.23333 6.76667C4.23333 6.56667 4.36667 6.43333 4.56667 6.43333H8.83333C9.03333 6.43333 9.16667 6.56667 9.16667 6.76667C9.16667 6.96667 9.03333 7.1 8.83333 7.1H4.56667C4.4 7.1 4.23333 6.96667 4.23333 6.76667ZM4.56667 9.1H8.83333C9.03333 9.1 9.16667 8.96667 9.16667 8.76667C9.16667 8.56667 9.03333 8.43333 8.83333 8.43333H4.56667C4.36667 8.43333 4.23333 8.56667 4.23333 8.76667C4.23333 8.96667 4.4 9.1 4.56667 9.1ZM4.56667 11.0667H7.1C7.3 11.0667 7.43333 10.9333 7.43333 10.7333C7.43333 10.5333 7.3 10.4 7.1 10.4H4.56667C4.36667 10.4 4.23333 10.5333 4.23333 10.7333C4.23333 10.9 4.4 11.0667 4.56667 11.0667ZM14.1333 8.9C14.1333 9.06667 14.0667 9.23333 13.9333 9.36667L9.46667 13.7667C9.4 13.8333 9.33333 13.8667 9.26667 13.9L7.46667 14.6333C7.4 14.6667 7.1 14.7667 6.83333 14.5C6.66667 14.3333 6.6 14.1 6.7 13.8667L7.4 12.0667C7.43333 12 7.46667 11.9333 7.53333 11.8667L10.7333 8.7V4.66667H8.96667C8.76667 4.66667 8.63333 4.53333 8.63333 4.33333V2.66667H3.1C2.86667 2.66667 2.66667 2.86667 2.66667 3.1V12.5667C2.66667 12.8 2.86667 13 3.1 13H5.56667C5.76667 13 5.9 13.1333 5.9 13.3333C5.9 13.5333 5.76667 13.6667 5.56667 13.6667H3.1C2.5 13.6667 2 13.1667 2 12.5667V3.1C2 2.5 2.5 2 3.1 2H8.96667C9.1 2 9.16667 2.06667 9.2 2.1L11.3 4.1C11.4 4.2 11.4 4.33333 11.4 4.33333V8.03333L12 7.43333C12.2667 7.16667 12.6667 7.16667 12.9333 7.43333L13.9333 8.43333C14.0667 8.56667 14.1333 8.7 14.1333 8.9ZM9.3 4H10.2333L10.0667 3.83333L9.3 3.1V4ZM8.63333 13.4333L7.9 12.6667L7.4 13.9333L8.63333 13.4333ZM13.4667 8.86667L12.4667 7.9L8.26667 12.1L9.23333 13.1L13.4667 8.86667Z"
        fill="#2F74EE"
      />
    </svg>
  );
};

const TaskList = () => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2188 3.40625H9.10359C8.95847 2.99705 8.5677 2.70312 8.10938 2.70312H7.69758C7.55248 2.29388 7.16149 2 6.70312 2C6.24476 2 5.85377 2.29388 5.70867 2.70312H5.29688C4.83855 2.70312 4.44778 2.99705 4.30266 3.40625H3.1875C2.60595 3.40625 2.13281 3.87938 2.13281 4.46094V12.9453C2.13281 13.5269 2.60595 14 3.1875 14H10.2188C10.8003 14 11.2734 13.5269 11.2734 12.9453V4.46094C11.2734 3.87938 10.8003 3.40625 10.2188 3.40625ZM4.94531 3.75781C4.94531 3.56396 5.10302 3.40625 5.29688 3.40625H6C6.19416 3.40625 6.35156 3.24884 6.35156 3.05469C6.35156 2.86084 6.50927 2.70312 6.70312 2.70312C6.89698 2.70312 7.05469 2.86084 7.05469 3.05469C7.05469 3.24884 7.21209 3.40625 7.40625 3.40625H8.10938C8.30323 3.40625 8.46094 3.56396 8.46094 3.75781V4.10938H4.94531V3.75781ZM10.5703 12.9453C10.5703 13.1392 10.4126 13.2969 10.2188 13.2969H3.1875C2.99365 13.2969 2.83594 13.1392 2.83594 12.9453V4.46094C2.83594 4.26709 2.99365 4.10938 3.1875 4.10938H4.24219V4.46094C4.24219 4.65509 4.39959 4.8125 4.59375 4.8125H8.8125C9.00666 4.8125 9.16406 4.65509 9.16406 4.46094V4.10938H10.2188C10.4126 4.10938 10.5703 4.26709 10.5703 4.46094V12.9453Z"
        fill="#2F74EE"
      />
      <path
        d="M6.24859 8.12641C6.11132 7.98911 5.88871 7.98911 5.75141 8.12641L4.59376 9.28406L4.13921 8.82951C4.00194 8.69221 3.77933 8.69221 3.64204 8.82951C3.50474 8.96681 3.50474 9.18939 3.64204 9.32669L4.34518 10.0298C4.41381 10.0985 4.50379 10.1328 4.59376 10.1328C4.68374 10.1328 4.77372 10.0985 4.84234 10.0298L6.24859 8.62359C6.38589 8.48629 6.38589 8.26371 6.24859 8.12641Z"
        fill="#2F74EE"
      />
      <path
        d="M6.24859 5.66547C6.11132 5.52818 5.88871 5.52818 5.75141 5.66547L4.59376 6.82312L4.13921 6.36857C4.00194 6.23128 3.77933 6.23128 3.64204 6.36857C3.50474 6.50587 3.50474 6.72846 3.64204 6.86575L4.34518 7.5689C4.41381 7.63755 4.50379 7.67186 4.59376 7.67186C4.68374 7.67186 4.77372 7.63755 4.84234 7.5689L6.24859 6.16265C6.38589 6.02536 6.38589 5.80277 6.24859 5.66547Z"
        fill="#2F74EE"
      />
      <path
        d="M6.24859 10.5873C6.11132 10.4501 5.88871 10.4501 5.75141 10.5873L4.59376 11.745L4.13921 11.2905C4.00194 11.1532 3.77933 11.1532 3.64204 11.2905C3.50474 11.4278 3.50474 11.6504 3.64204 11.7877L4.34518 12.4908C4.41381 12.5594 4.50379 12.5938 4.59376 12.5938C4.68374 12.5938 4.77372 12.5594 4.84234 12.4908L6.24859 11.0845C6.38589 10.9472 6.38589 10.7246 6.24859 10.5873Z"
        fill="#2F74EE"
      />
      <path
        d="M9.51562 6.26562H7.40625C7.21209 6.26562 7.05469 6.42303 7.05469 6.61719C7.05469 6.81134 7.21209 6.96875 7.40625 6.96875H9.51562C9.70978 6.96875 9.86719 6.81134 9.86719 6.61719C9.86719 6.42303 9.70978 6.26562 9.51562 6.26562Z"
        fill="#2F74EE"
      />
      <path
        d="M9.51562 11.1875H7.40625C7.21209 11.1875 7.05469 11.3449 7.05469 11.5391C7.05469 11.7332 7.21209 11.8906 7.40625 11.8906H9.51562C9.70978 11.8906 9.86719 11.7332 9.86719 11.5391C9.86719 11.3449 9.70978 11.1875 9.51562 11.1875Z"
        fill="#2F74EE"
      />
      <path
        d="M9.51562 8.72656H7.40625C7.21209 8.72656 7.05469 8.88397 7.05469 9.07812C7.05469 9.27228 7.21209 9.42969 7.40625 9.42969H9.51562C9.70978 9.42969 9.86719 9.27228 9.86719 9.07812C9.86719 8.88397 9.70978 8.72656 9.51562 8.72656Z"
        fill="#2F74EE"
      />
    </svg>
  );
};

const blue = {
  100: '#DAECFF',
  200: '#80BFFF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E5',
};

const grey = {
  50: '#F3F6F9',
  100: '#E7EBF0',
  200: '#E0E3E7',
  300: '#CDD2D7',
  400: '#B2BAC2',
  500: '#A0AAB4',
  600: '#6F7E8C',
  700: '#3E5060',
  800: '#2D3843',
  900: '#1A2027',
};

const StyledTextareaElement = styled('textarea', {
  shouldForwardProp: (prop) =>
    !['ownerState', 'minRows', 'maxRows'].includes(prop.toString()),
})(
  ({ theme }) => `
  width: 320px;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 12px;
  border-radius: 12px;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 2px ${
    theme.palette.mode === 'dark' ? grey[900] : grey[50]
  };

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${
      theme.palette.mode === 'dark' ? blue[500] : blue[200]
    };
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }`
);
export const Calendarimg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 4.43245C7 4.27684 7 4.19903 6.9491 4.15423C6.89819 4.10944 6.82244 4.11915 6.67094 4.13857C5.54965 4.28229 4.76806 4.57508 4.17157 5.17157C3 6.34315 3 8.22876 3 12C3 15.7712 3 17.6569 4.17157 18.8284C5.34315 20 7.22876 20 11 20H13C16.7712 20 18.6569 20 19.8284 18.8284C21 17.6569 21 15.7712 21 12C21 8.22876 21 6.34315 19.8284 5.17157C19.2319 4.57508 18.4504 4.28229 17.3291 4.13857C17.1776 4.11915 17.1018 4.10944 17.0509 4.15424C17 4.19903 17 4.27684 17 4.43245L17 6.5C17 7.32843 16.3284 8 15.5 8C14.6716 8 14 7.32843 14 6.5L14 4.30005C14 4.15898 14 4.08844 13.9561 4.04451C13.9123 4.00059 13.8418 4.0005 13.7009 4.00031C13.4748 4 13.2412 4 13 4H11C10.7588 4 10.5252 4 10.2991 4.00031C10.1582 4.0005 10.0877 4.00059 10.0439 4.04452C10 4.08844 10 4.15898 10 4.30005L10 6.5C10 7.32843 9.32843 8 8.50001 8C7.67158 8 7 7.32843 7 6.5L7 4.43245Z"
        fill="#6D6868"
        fill-opacity="0.54"
      />
      <path d="M8.5 2.5L8.5 6.5" stroke="white" stroke-linecap="round" />
      <path d="M15.5 2.5L15.5 6.5" stroke="white" stroke-linecap="round" />
      <circle cx="7.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="10.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="13.5" r="0.5" fill="white" />
      <circle cx="7.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="10.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="13.5" cy="16.5" r="0.5" fill="white" />
      <circle cx="16.5" cy="16.5" r="0.5" fill="white" />
    </svg>
  );
};
export const Feedback = ({
  buyerCardOpen,
  setBuyerCardOpen,
  expandFeedback,
  setExpandFeedback,
  openFeedback,
  setOpenFeedback,
  OwnerExpanded,
  onClose,
  buyerId,
  proid,
  ownercardprop,
  rowData,
  userName,
  data,
  address,
  setAddress,
  user,
  proUniqueId,
  buyerpropertylist,
  userType,
  userEmail,
  marketShow,
  index,
  row,
  directcomm,
  userInitial,
}) => {
  const style = {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%',
    fontFamily: 'poppins',
  };

  const currentPage = window.location.pathname;

  const [noteDetails, setNoteDetails] = React.useState('');
  const [taskDetails, setTaskDetails] = React.useState('');
  const [noteSubject, setNoteSubject] = React.useState('');
  const [taskSubject, setTaskSubject] = React.useState('');
  const [anchorElMessage, setAnchorElMessage] = React.useState(null);
  const [optionsTask, setOptionsTask] = React.useState('To-do');
  const [value, setValue] = React.useState(0);
  const [filterDate, setfilterDate] = React.useState(null);
  const [duedate, setDuedate] = React.useState(null);
  const [filterDateform, setfilterDateform] = React.useState(null);
  const [duedateform, setDuedateform] = React.useState(null);
  const [errorMessages, setErrorMessage] = React.useState({
    subject: false,
    details: false,
    dueDate: false,
    dateRange: false,
  });
  const [isScheduleCheckBox, setIsScheduleCheckBox] = React.useState(false);
  const [isDoneCheckBox, SetIsDoneCheckBox] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [scheduleSubject, setScheduleSubject] = React.useState('');
  const [scheduleDetails, setScheduleDetails] = React.useState('');
  const [errorMessagesSch, setErrorMessageSch] = React.useState({
    subjectSch: false,
    detailsSch: false,
    dateSch: false,
    dateRangeSch: false,
  });

  const [schedule, setSchedule] = React.useState(false);
  const [datePickerAnchorEl, setDatePickerAnchorEl] = React.useState(false);
  const [calender, setCalender] = React.useState('');
  const [scheduledate, setScheduleDate] = React.useState(null);
  const [newDateValue, setnewDate] = React.useState(null);
  const [propertylistContactPage, setPropertylistContactPage] = React.useState(
    []
  );
  const [notes, setNotes] = React.useState([]);
  const [noteToEdit, setNoteToEdit] = React.useState(null);
  const [isNoteEdit, setIsNoteEdit] = React.useState(null);
  const [taskToEdit, setTaskToEdit] = React.useState(null);
  const [isEdit, setIsEdit] = React.useState(false);

  const updateTaskScrollRef = React.useRef(null);
  const updateNoteScrollRef = React.useRef(null);

  const [filteredTodos, setFilteredTodos] = React.useState({
    active: [],
    completed: [],
    pending: [],
  });

  const [loaderpart, setLoaderpart] = React.useState(false);
  const [sortedCategories, setSortedCategories] = React.useState();
  const [proidContactPage, setProidContactPage] = React.useState(proid || 0);
  const [proUniqueIdContactPage, setProUniqueIdContactPage] = React.useState(
    proUniqueId || 0
  );
  const [combinedData, setCombinedData] = React.useState([]);

  const nowSydneyDueDate = dayjs().tz('Australia/Sydney');
  const oneHourLaterDueDate = nowSydneyDueDate.add(1, 'hour');
  const twoHourLaterDueDate = nowSydneyDueDate.add(2, 'hour');
  const [expandedCategories, setExpandedCategories] = React.useState({
    active: true,
    pending: true,
    completed: true,
  });

  const [selproperty, setSelproperty] = React.useState(proid);
  const [selectedProperty, setSelectedProperty] = React.useState(null);
  const [locationMenu, setLocationMenu] = React.useState(false);
  const taskRefs = React.useRef({});
  const [highlightKey, setHighlightKey] = React.useState(null);
  const [errors, setErrors] = React.useState({ subject: '', details: '' });

  const validate = () => {
    let valid = true;
    let newErrors = { subject: '', details: '' };

    if (!noteSubject.trim()) {
      newErrors.subject = 'Subject is required';
      valid = false;
    }

    if (!noteDetails.trim()) {
      newErrors.details = 'Details are required';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const closeMenu = () => {
    return setLocationMenu(false);
  };

  const Propertylist = (value) => {
    if (userType == 'Vendor') {
      let url = PROPERTYLIST_COMMON + '/Vendor/' + buyerId;
      getApiCall(url).then((res) => {
        setProidContactPage(res?.data?.data[0]?.pd_Id);
        setProUniqueIdContactPage(res?.data?.data[0]?.pd_propertyId);
        if (currentPage.includes('/People')) {
          setAddress(res?.data?.data[0]?.pa_addressTwo);
        }
        setPropertylistContactPage(res?.data?.data);
      });
    } else if (userType == 'Buyer') {
      if (buyerId) {
        let url = PROPERTYLIST_COMMON + '/Buyer/' + buyerId;
        getApiCall(url).then((res) => {
          setPropertylistContactPage(res?.data?.data);
          setProidContactPage(res?.data?.data[0]?.pd_Id);
          setProUniqueIdContactPage(res?.data?.data[0]?.pd_propertyId);
          if (currentPage.includes('/People')) {
            setAddress(res?.data?.data[0]?.pa_addressTwo);
          }
        });
      }
    }
  };

  const handleDeleteTask = (item) => {
    const inputData = {
      binderId: item?.binder_id,
      transId: item.transobject ? item.transobject.id : null,
      assigneeId: buyerId,
      isDelete: 1,
    };
    postApiCall(USER_UPDATETASK, inputData).then((res) => {
      if (res?.data?.status == 1) {
        setTaskToEdit(null);
        setIsEdit(false);
        getTask();
        Swal.fire({
          title: 'Delete Task',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      }
    });
  };
  const handleDeleteNote = (item) => {
    const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
    const targetUserId = ownercardprop
      ? rowData?.user?.userId || row?.user?.userId || data?.user?.userId
      : buyerId;

    let input = {
      receiverType: targetUserType,
      receiverId: targetUserId,
      propertyId:
        item.propertyId || proidContactPage || proid || selproperty || 0,
      subject: item.subject,
      message: item.notesMessage,
      isDelete: 1,
      notesId: item.noteId,
    };
    addNote(input).then((res) => {
      getNotes({
        receiverType: targetUserType,
        receiverId: targetUserId,
        filter: 'property',
        propertyId:
          item.propertyId || proidContactPage || proid || selproperty || 0,
      }).then((res) => {
        setNotes(res?.data);
        Swal.fire({
          title: 'Note Deleted',
          text: 'Note Deleted Successfuly',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      });
    });
  };
  const handleExpandCollapse = (category) => {
    setExpandedCategories((prev) => ({
      ...prev,
      [category]: !prev[category],
    }));
  };
  const getFilteredMoxoAcions = async () => {
    try {
      const apiResponse = await getMoxoAcions();

      const result = {
        active: [],
        pending: [],
        completed: [],
      };

      if (apiResponse.data) {
        apiResponse.data.forEach((item) => {
          const isValid =
            (item.transobject && item.transobject.type === 'TODO') ||
            item.object_type === 'signature';

          if (!isValid) return;

          // determine status
          let status;

          if (item.object_type === 'signature') {
            status = item.signature?.status?.toLowerCase();
          } else {
            status = item.transobject?.status?.toLowerCase();
          }

          if (status == 'active') result.active.push(item);
          else if (status === 'pending') result.pending.push(item);
          else if (status === 'completed') result.completed.push(item);
        });
      }

      return result;
    } catch (error) {
      return { active: [], pending: [], completed: [] };
    }
  };

  const getTask = async () => {
    setFilteredTodos({ active: [], completed: [], pending: [] });
    let filter;
    try {
      const primaryUserTypeval = userType;
      filter = await getFilteredMoxoAcions();

      setFilteredTodos(filter);
      await filterfunc(filter);
      return filter;
    } catch (error) {
      console.error('Error in getTask', error);
    }
  };
  async function filterfunc(filter) {
    let active = [];
    let pending = [];
    let completed = [];
    filter.active.map(async (value) => {
      let status = false;
      if (value?.transobject?.propertyUniqueId == proUniqueIdContactPage) {
        status = true;
      }
      if (status == true) {
        active.push(value);
      }
    });
    filter.pending.map(async (value) => {
      let status = false;
      if (value?.transobject?.propertyUniqueId == proUniqueIdContactPage) {
        status = true;
      }
      if (status == true) {
        pending.push(value);
      }
    });
    filter.completed.map(async (value) => {
      let status = false;
      if (value?.transobject?.propertyUniqueId == proUniqueIdContactPage) {
        status = true;
      }
      if (status == true) {
        completed.push(value);
      }
    });

    await setFilteredTodos(() => ({
      active: active,
      pending: pending,
      completed: completed,
    }));

    setTimeout(() => {
      handleExpandCollapse('active');
      handleExpandCollapse('active');
      setLoaderpart(false);
    }, 3000);
  }

  React.useEffect(() => {
    if (currentPage.includes('/People')) {
      Propertylist();
    }
  }, []);

  React.useEffect(() => {
    if (proid) {
      setProidContactPage(proid);
      setSelproperty(proid);
    }
  }, [proid]);

  React.useEffect(() => {
    if (proUniqueId) {
      setProUniqueIdContactPage(proUniqueId);
    }
  }, [proUniqueId]);

  React.useEffect(() => {
    if (buyerpropertylist && buyerpropertylist.length > 0) {
      setPropertylistContactPage(buyerpropertylist);
      if (!proidContactPage || proidContactPage === 0) {
        setProidContactPage(buyerpropertylist[0]?.pd_Id);
        setSelproperty(buyerpropertylist[0]?.pd_Id);
        setProUniqueIdContactPage(buyerpropertylist[0]?.pd_propertyId);
        setAddress(buyerpropertylist[0]?.pa_addressTwo);
      }
    }
  }, [buyerpropertylist, proidContactPage]);

  React.useEffect(() => {
    setLoaderpart(true);
    getTask();
  }, [proidContactPage, proUniqueIdContactPage]);

  const getNoteListApi = (id, ownercardprop) => {
    const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
    const targetUserId = ownercardprop
      ? data?.user?.userId || rowData?.user?.userId || row?.user?.userId
      : buyerId;

    getNotes({
      receiverType: targetUserType,
      receiverId: targetUserId,
      filter: 'property',
      propertyId: proidContactPage,
    }).then((res) => {
      setNotes(res?.data);
    });
  };
  React.useEffect(() => {
    if (selproperty && buyerpropertylist.length >= 1) {
      const property = buyerpropertylist.find(
        (item) => item?.pd_Id === selproperty
      );
      setSelectedProperty(property);
    }
  }, [selproperty, buyerpropertylist]);

  const handleUpdateNote = () => {
    if (!validate()) return;
    if (noteSubject != '' && noteDetails != '') {
      const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
      const targetUserId = ownercardprop
        ? rowData?.user?.userId || row?.user?.userId || data?.user?.userId
        : buyerId;

      let input = {
        receiverType: targetUserType,
        receiverId: targetUserId,
        propertyId: proidContactPage || proid || selproperty || 0,
        subject: noteSubject,
        message: noteDetails,
        notesId: noteToEdit.noteId,
      };

      addNote(input).then((res) => {
        setNoteSubject('');
        setNoteDetails('');
        setNoteToEdit(null);
        setIsNoteEdit(null);
        getNotes({
          receiverType: targetUserType,
          receiverId: targetUserId,
          filter: 'property',
          propertyId: proidContactPage || proid || selproperty || 0,
        }).then((res) => {
          setNotes(res?.data);
          if (!ownercardprop) {
            Swal.fire({
              title: 'Note Updated',
              text: 'Note Updated Successfuly',
              showDenyButton: false,
              showCancelButton: false,
              icon: 'success',
              confirmButtonText: 'Close',
            });
          }
        });
      });
    }
  };

  React.useEffect(() => {
    getNoteListApi(buyerId, ownercardprop);
  }, [proidContactPage, proUniqueIdContactPage]);

  React.useEffect(() => {
    const categoryOrder = ['active', 'pending', 'completed'];

    setSortedCategories(
      Object.entries(filteredTodos).sort(
        ([categoryA], [categoryB]) =>
          categoryOrder.indexOf(categoryA) - categoryOrder.indexOf(categoryB)
      )
    );
  }, [filteredTodos?.active?.length]);

  function formatTimestamp(timestampStr) {
    const timestamp = parseInt(timestampStr, 10);
    const date = new Date(timestamp);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, '0');

    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  }

  React.useEffect(() => {
    let categoryObj;

    categoryObj = Object.fromEntries(sortedCategories || []);

    const allTasks = [
      ...(categoryObj.active || []),
      ...(categoryObj.pending || []),
      ...(categoryObj.completed || []),
    ];
    const tasksList = allTasks.map((ele) => {
      let objecttype = ele.object_type == 'signature' ? true : false;
      return {
        ...ele,
        createdAt: objecttype
          ? formatTimestamp(ele.signature.created_time)
          : formatTimestamp(ele.transobject.created_time),
        isTask: true,
        updatedAt: formatTimestamp(ele.updated_time),
        subject: objecttype ? ele.signature.file_name : ele.transobject.title,
        description: objecttype
          ? ele.signature?.flow?.description
          : ele.transobject.sub_title,
        status: objecttype ? ele.signature.status : ele.transobject.status,
      };
    });

    const notesList = (Array.isArray(notes) ? notes : []).map((ele) => {
      return {
        ...ele,
        isTask: false,
        description: ele.notesMessage,
        createdAt: ele.createdAt || '',
      };
    });

    const merged = [...tasksList, ...notesList];
    const sortedMerged = merged.sort(
      (a, b) =>
        dayjs(b.createdAt, 'DD-MM-YYYY hh:mm A').valueOf() -
        dayjs(a.createdAt, 'DD-MM-YYYY hh:mm A').valueOf()
    );

    setCombinedData(sortedMerged);
  }, [sortedCategories, filteredTodos, notes]);

  const handleCloseDatePIcker = () => {
    setDatePickerAnchorEl(null);
  };

  const getDateValue = (newdate) => {
    if (newdate !== null) {
      const formattedDate = dayjs(newdate)
        .locale('en')
        .format('DD MMMM YYYY [at] hh:mma');

      const formatted = dayjs(newdate)
        .locale('en')
        .format('YYYY-MM-DD HH:mm:ss');

      if (calender === 'Due') {
        setDuedateform(formatted);
        setDuedate(formattedDate);

        const nowSydney = dayjs().tz('Australia/Sydney');
        const oneHourFiveMinutesLater = nowSydney
          .add(1, 'hour')
          .add(1, 'minutes');
        const selectedDate = dayjs(newdate).tz('Australia/Sydney');

        const isFuture = selectedDate.isAfter(oneHourFiveMinutesLater);
        setScheduleDate(isFuture);
      } else {
        setfilterDateform(formatted);
        setfilterDate(formattedDate);
      }
    }
  };

  const handleSaveSchClicked = () => {
    if (scheduleSubject == '') {
      setErrorMessageSch((prev) => ({
        ...prev,
        subjectSch: true,
      }));
    } else if (scheduleDetails == '') {
      setErrorMessageSch((prev) => ({
        ...prev,
        detailsSch: true,
      }));
    } else if (filterDateform == null) {
      setErrorMessageSch((prev) => ({
        ...prev,
        dateSch: true,
      }));
    } else {
      setSchedule(false);
      setErrorMessageSch((prev) => ({
        ...prev,
        dateRangeSch: false,
      }));
    }
  };

  const handleSaveTaskClicked = () => {
    if (taskSubject == '') {
      setErrorMessage((prev) => ({
        ...prev,
        subject: true,
      }));
    } else if (taskDetails == '') {
      setErrorMessage((prev) => ({
        ...prev,
        details: true,
      }));
    } else if (duedate == null) {
      setErrorMessage((prev) => ({
        ...prev,
        dueDate: true,
      }));
    } else {
      if (isEdit) {
        handleUpdateTask();
      } else {
        handleSaveTask();
        setErrorMessage((prev) => ({
          ...prev,
          dateRange: false,
        }));
      }
    }
  };

  const AddNote = () => {
    if (!validate()) return;
    if (noteSubject != '' && noteDetails != '') {
      const targetUserType = ownercardprop ? 'Vendor' : 'Buyer';
      const targetUserId = ownercardprop
        ? row?.user?.userId || rowData?.user?.userId || data?.user?.userId
        : buyerId;

      let input = {
        receiverType: targetUserType,
        receiverId: targetUserId,
        propertyId: proidContactPage || proid || selproperty || 0,
        subject: noteSubject,
        message: noteDetails,
      };

      addNote(input).then((addRes) => {
        setNoteSubject('');
        setNoteDetails('');
        if (ownercardprop) {
          Swal.fire({
            title: addRes?.heading ? addRes?.heading : 'Vendor Note',
            text: addRes?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
          getNotes({
            receiverType: targetUserType,
            receiverId: targetUserId,
            filter: 'property',
            propertyId: proidContactPage || proid || selproperty || 0,
          }).then((getRes) => {
            setNotes(getRes?.data);
          });
        } else {
          getNotes({
            receiverType: targetUserType,
            receiverId: targetUserId,
            filter: 'property',
            propertyId: proidContactPage || proid || selproperty || 0,
          }).then((getRes) => {
            setNotes(getRes?.data);
            Swal.fire({
              title: addRes?.heading ? addRes?.heading : 'Buyer Note',
              text: addRes?.message,
              showDenyButton: false,
              showCancelButton: false,
              icon: 'success',
              confirmButtonText: 'Close',
            });
          });
        }
      });
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeAddress = (event) => {
    setLocationMenu(false);
    let values;
    if (propertylistContactPage && propertylistContactPage.length > 1) {
      propertylistContactPage?.map((item) => {
        if (item.pd_Id == event.target.value) {
          values = item?.pd_propertyId;
          setAddress(item?.pa_addressTwo);
        }
      });
    }
    const selectedPropertyId = event.target.value;
    setProidContactPage(selectedPropertyId);
    setProUniqueIdContactPage(values);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  const useStyles = makeStyles({
    tab: {
      minHeight: '36.68px',
    },
  });

  React.useEffect(() => {
    if (isNoteEdit) {
      setNoteSubject(noteToEdit.subject);
      setNoteDetails(noteToEdit.notesMessage);
    }
  }, [isNoteEdit, noteToEdit]);

  React.useEffect(() => {
    if (isEdit) {
      setTaskSubject(taskToEdit?.transobject?.title);
      setTaskDetails(taskToEdit?.transobject?.sub_title);
      const duedate = dayjs(taskToEdit?.transobject?.expiration_date)
        .locale('en')
        .format('DD MMMM YYYY [at] hh:mma');
      const formatteddate = dayjs(taskToEdit?.transobject?.expiration_date)
        .locale('en')
        .format('YYYY-MM-DD HH:mm:ss');
      setDuedate(duedate);
      setDuedateform(formatteddate);
      const taskcode = taskToEdit?.transobject?.type;
      if (taskcode == 'TODO') {
        setOptionsTask('To-do');
      } else if (taskcode == 'TRANSACTION_TYPE_CALL') {
        setOptionsTask('call');
      } else if (taskcode == 'TRANSACTION_TYPE_VOICECALL') {
        setOptionsTask('voice-call');
      }
      setScheduleDate(true);
    }
  }, [isEdit, taskToEdit]);

  const CircularProgressWithProfile = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={43}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={43}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props?.profileImage == '' || props?.profileImage == null ? (
              <Avatar
                style={{
                  width: '36px',
                  height: '36px',
                  backgroundColor: '#666666',
                  fontFamily: 'poppins',
                  fontSize: '15px',
                }}
              >
                {props?.name}
              </Avatar>
            ) : (
              <Avatar
                alt={props?.name}
                src={props?.profileImage}
                style={{
                  width: '36px',
                  height: '36px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  };

  const handleSaveTask = () => {
    const taskData = {
      propertyId: proidContactPage,
      assigneeId: buyerId,
      title: taskSubject,
      comment: taskDetails,
      dueDateTime: duedateform,
      isSchedule: isScheduleCheckBox ? 1 : 0,
      scheduleTitle: scheduleSubject,
      scheduleComment: scheduleDetails,
      scheduleDueDateTime: filterDateform,
      taskType: optionsTask,
      isDone: isDoneCheckBox ? 1 : 0,
    };

    setIsLoading(true);
    postApiCall(USER_STORETASK, taskData).then((res) => {
      setIsLoading(false);
      if (res?.data?.status == 1) {
        setTaskSubject('');
        setTaskDetails('');
        setDuedate(null);
        setScheduleSubject('');
        setScheduleDetails('');
        SetIsDoneCheckBox(false);
        setIsScheduleCheckBox(false);
        setfilterDate(null);
        setfilterDateform(null);
        setDuedate(null);
        setDuedateform(null);
        setErrorMessage({
          subject: false,
          details: false,
          dueDate: false,
        });
        Swal.fire({
          title: 'Task Created',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      }
    });
  };
  const handleUpdateTask = () => {
    const inputData = {
      binderId: taskToEdit?.binder_id,
      assigneeId: buyerId,
      transId: taskToEdit?.transobject?.id || taskToEdit?.signature?.id,
      title: taskSubject,
      isDone: 0,
      isDelete: 0,
      comment: taskDetails,
      dueDateTime: duedateform,
      isSchedule: isScheduleCheckBox ? 1 : 0,
      scheduleTitle: scheduleSubject,
      scheduleComment: scheduleDetails,
      scheduleDueDateTime: filterDateform,
      taskType: optionsTask,
      propertyId: proidContactPage,
    };
    setIsLoading(true);
    postApiCall(USER_UPDATETASK, inputData).then((res) => {
      setIsLoading(false);
      if (res?.data?.status == 1) {
        setTaskSubject('');
        setTaskDetails('');
        setDuedate(null);
        setScheduleSubject('');
        setScheduleDetails('');
        SetIsDoneCheckBox(false);
        setIsScheduleCheckBox(false);
        setfilterDate(null);
        setfilterDateform(null);
        setDuedate(null);
        setDuedateform(null);
        setErrorMessage({
          subject: false,
          details: false,
          dueDate: false,
        });
        setTaskToEdit(null);
        setIsEdit(false);
        getTask();
        Swal.fire({
          title: 'Update',
          text: res?.data?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  const classes = useStyles();

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      {!OwnerExpanded ? (
        <Dialog
          open={openFeedback || expandFeedback}
          onClose={() => {
            setOpenFeedback(false);
            setExpandFeedback(false);
            setPropertylistContactPage([]);
          }}
          PaperProps={{
            sx: {
              m: 0,
              background: '#FFFFFF',
              boxShadow: '0px 4px 60px rgba(22, 58, 95, 0.07)',
              borderRadius: '4px',
              maxWidth: matchessm ? '90%' : '850px',
              overflow: 'scroll',
              zIndex: 9999,
            },
          }}
          maxWidth={matchessm ? '90%' : '850px'}
        >
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: matchessm ? '10px' : '30px',
              gap: '23px',
              width: matchessm ? '100%' : '823px',
            }}
          >
            <Grid
              item
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                padding: '0px',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: matchessm ? 'row' : 'row',
                  justifyContent: 'space-between',
                  alignItems: matchessm ? 'center' : 'center',
                  padding: '0px',
                  gap: matchessm ? '10px' : '20px',
                  width: matchessm ? '100%' : '100%',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 1,
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ height: '48px' }}>
                    <Typography
                      sx={{ ...poppins600, fontSize: '32px', color: '#262626' }}
                    >
                      Notes
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'flex-start',
                      justifyContent: matchessm && 'space-between',
                      padding: '0px',
                      gap: matchessm ? '5px' : '15px',
                      width: matchessm ? '100%' : 'auto',
                    }}
                  >
                    {userType == 'Buyer' ? (
                      <Button
                        disableRipple
                        disableTouchRipple
                        variant="outlined"
                        sx={{
                          border: '1px solid #6C2AD2',
                          color: '#6C2AD2',
                          ...poppins400,
                          fontSize: '12px',
                          cursor: 'default',
                        }}
                      >
                        {' '}
                        #Buyer
                      </Button>
                    ) : userType == 'Vendor' ? (
                      <Button
                        variant="outlined"
                        disableRipple
                        disableTouchRipple
                        sx={{
                          border: '1px solid  #4CA4D6',
                          color: ' #4CA4D6',
                          ...poppins400,
                          fontSize: '12px',
                          cursor: 'default',
                        }}
                      >
                        {' '}
                        #Owner
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        sx={{
                          border: '1px solid #666666',
                          color: '#666666',
                          ...poppins400,
                          fontSize: '12px',
                        }}
                      >
                        {' '}
                        #Appraisal
                      </Button>
                    )}
                  </Box>
                </Box>

                <IconButton
                  onClick={() => {
                    setOpenFeedback(false);
                    setExpandFeedback(false);
                    setPropertylistContactPage([]);
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start',
                  padding: '0px',
                  width: matchessm ? '100%' : '744px',
                  height: '83px',
                  marginTop: matchessm ? '10px' : 'auto',
                }}
              >
                <Box>
                  <Box
                    sx={{
                      height: '55px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'start',
                      gap: '10px',
                    }}
                  >
                    <CircularProgressWithProfile
                      value={row?.profileActivity}
                      profileImage={row?.user?.userProfile}
                      name={userInitial}
                    />

                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '12px',
                        color: '#112347',
                        textAlign: 'center',
                      }}
                    >
                      {userName}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: matchessm ? 'start' : 'center',
                      padding: '0px',
                      gap: '5px',
                      position: 'absolute',
                      width: '90%',
                    }}
                  >
                    <Location />
                    <Typography
                      sx={{ ...poppins300, fontSize: '12px', color: '#112347' }}
                    >
                      <Tooltip
                        title={address || ''}
                        placement="bottom"
                        disableInteractive
                        componentsProps={{
                          tooltip: {
                            sx: {
                              bgcolor: '#fafafa',
                              boxShadow: '0px 2px 20px lightgray',
                              color: 'black',
                              padding: '10px',
                              fontFamily: 'poppins !important',
                              fontSize: '14px',
                              maxWidth: '1000px',
                            },
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            width: '80%',
                            textOverflow: 'ellipsis',
                            whiteSpace: matchessm ? 'wrap' : 'nowrap',
                            overflow: 'hidden',
                            pl: 1,
                            ...poppins400,
                            fontSize: '12px',
                          }}
                        >
                          {' '}
                          {address}
                        </Typography>
                      </Tooltip>
                      <Select
                        value={selproperty}
                        onChange={handleChangeAddress}
                        open={locationMenu}
                        onClose={closeMenu}
                        sx={{ width: 0, height: 0, opacity: 0, p: 0 }}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              overflowX: 'scroll',
                            },
                          },
                        }}
                      >
                        {propertylistContactPage?.map((value) => (
                          <MenuItem
                            key={value.pd_Id}
                            value={value.pd_Id}
                            sx={{
                              fontSize: matchessm ? '8px' : '14px',
                              minHeight: matchessm ? '8px' : '10px',
                            }}
                          >
                            {value?.pa_addressTwo}
                          </MenuItem>
                        ))}
                      </Select>

                      <IconButton
                        onClick={() => setLocationMenu(!locationMenu)}
                      >
                        <ArrowDown />
                      </IconButton>
                    </Typography>
                    <Box
                      sx={{
                        width: matchessm ? '10px' : '14px',
                        height: matchessm ? '10px' : '14px',
                        marginTop: matchessm ? '0px' : '-12px',
                      }}
                    >
                      <CancelOutlinedIcon />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    padding: '9px 0px',
                    gap: '15px',
                    width: '75px',
                    height: '48px',
                  }}
                >
                  <Contact
                    openFeedback={openFeedback}
                    setOpenFeedback={setOpenFeedback}
                    row={row}
                    directcomm={directcomm}
                    index={null}
                    buyerCardOpen={buyerCardOpen}
                    setBuyerCardOpen={setBuyerCardOpen}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: matchessm ? '10px' : '15px',
                width: '100%',
                background: '#FFFFFF',
                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                bordeRadius: '5px',
                padding: matchessm ? '5px' : '10px',
              }}
            >
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  padding: '0px',
                  width: '100%',
                }}
              >
                <Box sx={{ width: '100%' }}>
                  <Tabs
                    style={{
                      color: 'purpleHeart',
                      borderBottom: 'purpleheart',
                      display: 'false',
                    }}
                    value={value}
                    onChange={handleChange}
                    aria-label=" tabs example"
                    sx={{
                      width: '100%',
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#fffff',
                        marginBottom: '5px',
                      },
                      '& .MuiTab-root.Mui-selected': {
                        color: '#2F74EE',
                        background: 'rgba(0, 101, 252, 0.1)',
                        width: '67.13px',
                        height: '36.68px',
                        p: '0px',
                      },
                    }}
                  >
                    <Tab
                      style={{ minHeight: '39.68px', padding: '0px' }}
                      className={classes.tab}
                      label="Notes"
                      icon={<Notetask />}
                      {...a11yProps(0)}
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '12px',
                        textTransform: 'capitalize',
                      }}
                    />

                    <Tab
                      style={{ minHeight: '39.68px', padding: '0px' }}
                      className={classes.tab}
                      label="Task"
                      icon={<TaskList />}
                      {...a11yProps(1)}
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '12px',
                        textTransform: 'none',
                      }}
                    />
                  </Tabs>
                  <TabPanel
                    value={value}
                    index={0}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '25px',
                    }}
                  >
                    <Box
                      ref={updateNoteScrollRef}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0px',
                        gap: '10px',
                        width: matchessm ? '100%' : '100%',
                        height: '36px',
                        marginTop: '15px',
                      }}
                    >
                      <TextField
                        value={noteSubject}
                        onChange={(e) => setNoteSubject(e.currentTarget.value)}
                        placeholder="Subject"
                        variant="standard"
                        error={!!errors.subject}
                        helperText={errors.subject}
                        InputProps={{
                          disableUnderline: true,
                          sx: {
                            ml: 1,
                            flex: 1,
                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'Poppins',
                            '&::placeholder': {
                              color: '#8B8B8B',
                              fontSize: '14px',
                              fontWeight: 400,
                              fontFamily: 'Poppins',
                              opacity: 1,
                            },
                            '.MuiFormHelperText-contained': {
                              margin: '0',
                              fontFamily: 'poppins',
                            },
                          },
                        }}
                        FormHelperTextProps={{
                          sx: {
                            fontFamily: 'Poppins',
                            fontSize: '11px',
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            fontFamily: 'poppins',
                          },
                          '& .MuiInputLabel-root': {
                            fontFamily: 'poppins',
                          },
                          '.MuiFormHelperText-contained': {
                            margin: '0',
                            fontFamily: 'poppins',
                          },
                          backgroundColor: '#FFFFFF',
                          border: '0.5px solid #D9D9D9',
                          borderRadius: '5px',
                          height: '36px',
                          width: '100%',
                        }}
                      />
                      <Box
                        sx={{
                          width: matchessm ? '40%' : '126px',
                        }}
                      >
                        <Select
                          sx={{
                            ...poppins400,
                            fontSize: '12px',
                            color: '#666666',
                            borderRadius: '4px',
                            height: '36px',
                            width: '100%',
                            background: '#FFFFFF',
                            p: '0px',
                          }}
                          size="small"
                          defaultValue="Buyer-Report"
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          <MenuItem
                            sx={{ ...poppins300 }}
                            value={'Buyer-Report'}
                          >
                            Buyer Report
                          </MenuItem>
                          <MenuItem sx={{ ...poppins300 }} value={'report'}>
                            Call
                          </MenuItem>
                          <MenuItem sx={{ ...poppins300 }} value={'report'}>
                            Voice Call
                          </MenuItem>
                        </Select>
                      </Box>
                    </Box>
                    <Grid
                      item
                      sx={{
                        width: matchessm ? '100%' : '100%',
                      }}
                    >
                      <TextField
                        sx={{
                          width: '100%',
                          borderRadius: '0px',
                          '& .MuiOutlinedInput-root': {
                            fontFamily: 'poppins',
                          },
                          '& .MuiInputLabel-root': {
                            fontFamily: 'poppins',
                          },
                          '.MuiFormHelperText-contained': {
                            margin: '0',
                            fontFamily: 'poppins',
                          },
                        }}
                        variant="outlined"
                        placeholder="Details"
                        multiline
                        value={noteDetails}
                        rows={6}
                        error={!!errors.details}
                        helperText={errors.details}
                        onChange={(e) => {
                          setNoteDetails(e.currentTarget.value);
                        }}
                        inputProps={{ style: { fontFamily: 'poppins' } }}
                      />
                    </Grid>
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: matchessm ? 'column' : 'row',
                        justifyContent: 'flex-end',
                        alignItems: matchessm ? 'end' : 'center',
                        padding: '0px',
                        gap: '5px',
                        width: '100%',
                        paddingBottom: '10px',
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            height: '17px',
                            background: '#0BC4ED',
                            borderRadius: ' 5px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '1px 10px',
                          }}
                        >
                          {/* <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              lineHeight: '18px',
                              color: '#FFFFFF',
                            }}
                          >
                            -{' '}
                          </Typography> */}

                          <Typography
                            sx={{
                              color: '#FFFFFF',
                              ...poppins500,
                              fontSize: '10px',
                            }}
                          >
                            #Public
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <Button
                          sx={{
                            width: '153px',
                            height: '34px',
                            border: '0.5px solid #D9D9D9',
                            bordeRadius: '5px',
                            minWidth: '153px',
                            p: '0px',
                          }}
                          onClick={(e) => {
                            setAnchorElMessage(e.currentTarget);
                          }}
                        >
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              color: '#272727',
                              textTransform: 'none',
                            }}
                          >
                            + Insert Template Text
                          </Typography>
                        </Button>
                      </Box>
                      <Box>
                        <Typography>
                          <Button
                            sx={{
                              width: isNoteEdit ? '110px' : '86px',
                              ...poppins400,
                              fontSize: '12px',
                              color: '#6C2AD2',
                              height: '35px',
                              background: '#ECE5F6',
                              borderRadius: ' 5px',
                              textTransform: 'none',
                            }}
                            onClick={() => {
                              isNoteEdit ? handleUpdateNote() : AddNote();
                            }}
                          >
                            {isNoteEdit ? 'Save Changes' : 'Add Note'}
                          </Button>
                        </Typography>
                      </Box>
                      <Box>
                        {isLoading && (
                          <img
                            alt="Loader"
                            src={Loading}
                            className="loaderImage"
                            style={{ height: '40px', width: '40px' }}
                          />
                        )}
                      </Box>
                    </Grid>
                  </TabPanel>
                  <TabPanel
                    value={value}
                    index={1}
                    sx={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '25px',
                    }}
                  >
                    <Box
                      ref={updateTaskScrollRef}
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        padding: '0px',
                        gap: '10px',
                        width: matchessm ? '100%' : '100%',
                        height: '36px',
                        marginTop: '15px',
                      }}
                    >
                      <Box sx={{ width: matchessm ? '50%' : '592px' }}>
                        <Box
                          component="form"
                          sx={{
                            p: '2px 4px',
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#FFFFFF',
                            border: '0.5px solid #D9D9D9',
                            borderRadius: '5px',
                            height: '36px',
                          }}
                        >
                          <InputBase
                            value={taskSubject}
                            onChange={(e) => {
                              setTaskSubject(e.currentTarget.value);
                              setErrorMessage((prev) => ({
                                ...prev,
                                subject: false,
                              }));
                            }}
                            sx={{
                              ml: 1,
                              flex: 1,
                              '& ::placeholder': {
                                color: '#8B8B8B',
                                fontSize: '14px',
                                fontWeight: 400,
                                fontFamily: 'poppins',
                                opacity: 1,
                              },

                              fontSize: '14px',
                              fontWeight: 400,
                              fontFamily: 'poppins',
                            }}
                            placeholder="Subject"
                            inputProps={{ 'aria-label': 'Search here' }}
                          />
                        </Box>
                        {errorMessages.subject && (
                          <Typography
                            sx={{
                              fontSize: '12px',
                              color: 'red',
                              fontFamily: 'Poppins',
                              mt: '1px',
                              ml: '4px',
                            }}
                          >
                            Subject is required.
                          </Typography>
                        )}
                      </Box>

                      <Box
                        sx={{
                          width: matchessm ? '40%' : '126px',
                        }}
                      >
                        <Select
                          sx={{
                            ...poppins400,
                            fontSize: '12px',
                            color: '#666666',
                            border: '0.5px solid #D9D9D9',
                            borderRadius: '4px',
                            height: '36px',
                            width: '100%',
                            background: '#FFFFFF',
                            p: '0px',
                          }}
                          size="small"
                          defaultValue="To-do"
                          onChange={(e) => setOptionsTask(e.target.value)}
                          displayEmpty
                          inputProps={{ 'aria-label': 'Without label' }}
                        >
                          <MenuItem sx={{ ...poppins300 }} value={'To-do'}>
                            To Do
                          </MenuItem>
                          <MenuItem sx={{ ...poppins300 }} value={'report'}>
                            Call
                          </MenuItem>
                          <MenuItem sx={{ ...poppins300 }} value={'report'}>
                            Voice Call
                          </MenuItem>
                        </Select>
                      </Box>
                    </Box>
                    <Grid
                      item
                      sx={{
                        width: matchessm ? '100%' : '100%',
                      }}
                    >
                      <TextField
                        variant="standard"
                        multiline
                        value={taskDetails}
                        rows={5}
                        InputProps={{ disableUnderline: true }}
                        style={{
                          width: '100%',
                          height: '153px',
                          padding: matchessm
                            ? '0px 0px 10px 10px'
                            : '0px 0px 10px 13px',
                          fontFamily: 'poppins',
                        }}
                        placeholder="Details"
                        sx={{
                          '& .MuiInputBase-input': {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            color: 'black',
                          },
                          '& textarea::placeholder': {
                            color: '#8B8B8B',
                            fontSize: '14px',
                            fontWeight: 400,
                            fontFamily: 'Poppins',
                            opacity: 1,
                          },
                          border: '0.5px solid #D9D9D9',
                          borderRadius: '5px',
                          background: '#FFFFFF',
                          color: 'black',
                        }}
                        onChange={(e) => {
                          setTaskDetails(e.currentTarget.value);
                          setErrorMessage((prev) => ({
                            ...prev,
                            details: false,
                          }));
                        }}
                      />
                      {errorMessages.details && (
                        <Typography
                          sx={{
                            fontSize: '12px',
                            color: 'red',
                            fontFamily: 'Poppins',
                            mt: '1px',
                            ml: '4px',
                          }}
                        >
                          Details is required.
                        </Typography>
                      )}
                    </Grid>

                    <Grid
                      xs={12}
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: matchessm ? 'column' : 'row',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Grid item>
                        <Stack
                          direction={'row'}
                          spacing={1}
                          alignItems={'center'}
                          component={'span'}
                        >
                          <IconButton
                            onClick={(e) => {
                              setCalender('Due');
                              setDatePickerAnchorEl(e.currentTarget);
                            }}
                          >
                            <Calendarimg />
                          </IconButton>
                          <Typography sx={{ ...poppins300, fontWeight: '500' }}>
                            {duedate ? duedate : 'Due Date'}
                          </Typography>
                        </Stack>
                        {errorMessages.dueDate && (
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '12px',
                              color: 'red',
                              paddingLeft: '12px',
                            }}
                          >
                            Due date and time is required
                          </Typography>
                        )}
                        {errorMessages.dateRange && (
                          <Typography
                            sx={{
                              fontFamily: 'poppins',
                              fontSize: '12px',
                              color: 'red',
                              paddingLeft: '12px',
                            }}
                          >
                            Select a valid date and time
                          </Typography>
                        )}
                      </Grid>
                      {duedate && !scheduledate && (
                        <Grid item>
                          <FormControlLabel
                            control={
                              <Checkbox
                                disableRipple
                                sx={{
                                  p: '3px',
                                  paddingRight: '0px',
                                }}
                                checked={isScheduleCheckBox}
                                onChange={(e) => {
                                  setCalender('schedule');
                                  setIsScheduleCheckBox(e.target.checked);
                                  setSchedule(e.target.checked);
                                }}
                              />
                            }
                            label={
                              <Typography
                                sx={{
                                  ...poppins300,
                                  ml: '10px',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Schedule follow up?
                              </Typography>
                            }
                          />
                        </Grid>
                      )}
                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          justifyContent: matchessm ? 'start' : 'end',
                        }}
                      >
                        <FormControlLabel
                          sx={{
                            marginRight: '0px',
                          }}
                          control={
                            <Checkbox
                              disableRipple
                              checked={isDoneCheckBox}
                              onChange={(e) =>
                                SetIsDoneCheckBox(e.target.checked)
                              }
                              sx={{
                                p: '3px',
                                paddingRight: '0px',
                              }}
                            />
                          }
                          label={
                            <Typography sx={{ ...poppins300, ml: '10px' }}>
                              Mark as done
                            </Typography>
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      sx={{
                        display: 'flex',
                        flexDirection: matchessm ? 'column' : 'row',
                        justifyContent: 'flex-end',
                        alignItems: matchessm ? 'end' : 'center',
                        padding: '0px',
                        gap: '5px',
                        width: '100%',
                        paddingBottom: '10px',
                      }}
                    >
                      <Box>
                        <Box
                          sx={{
                            height: '17px',
                            background: '#0BC4ED',
                            borderRadius: ' 5px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '1px 10px',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#FFFFFF',
                              ...poppins500,
                              fontSize: '10px',
                            }}
                          >
                            #External
                          </Typography>
                        </Box>
                      </Box>
                      <Box>
                        <Button
                          sx={{
                            width: '153px',
                            height: '34px',
                            border: '0.5px solid #D9D9D9',
                            bordeRadius: '5px',
                            minWidth: '153px',
                            p: '0px',
                          }}
                          onClick={(e) => {
                            setAnchorElMessage(e.currentTarget);
                          }}
                        >
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '12px',
                              color: '#272727',
                              textTransform: 'none',
                            }}
                          >
                            + Insert Template Text
                          </Typography>
                        </Button>
                      </Box>
                      <Box>
                        <Typography>
                          <Button
                            onClick={handleSaveTaskClicked}
                            sx={{
                              width: '86px',
                              ...poppins400,
                              fontSize: '12px',
                              color: '#6C2AD2',
                              height: '35px',
                              background: '#ECE5F6',
                              borderRadius: ' 5px',
                              textTransform: 'none',
                            }}
                            disabled={isLoading}
                          >
                            {isEdit ? 'Edit Task' : 'Add Task'}
                          </Button>
                        </Typography>
                      </Box>
                      <Box>
                        {isLoading && (
                          <img
                            alt="Loader"
                            src={Loading}
                            className="loaderImage"
                            style={{ height: '40px', width: '40px' }}
                          />
                        )}
                      </Box>
                    </Grid>
                  </TabPanel>
                </Box>
              </Grid>

              <Grid
                item
                sx={{
                  width: '100%',
                }}
              >
                <FeedbackDocumentation
                  handleDeleteTask={handleDeleteTask}
                  handleDeleteNote={handleDeleteNote}
                  proid={proidContactPage}
                  buyerId={buyerId}
                  setValue={setValue}
                  value={value}
                  notes={notes}
                  setNotes={setNotes}
                  handleUpdateNote={handleUpdateNote}
                  noteToEdit={noteToEdit}
                  setNoteToEdit={setNoteToEdit}
                  setIsNoteEdit={setIsNoteEdit}
                  isNoteEdit={isNoteEdit}
                  updateNoteScrollRef={updateNoteScrollRef}
                  loaderpart={loaderpart}
                  sortedCategories={sortedCategories}
                  handleExpandCollapse={handleExpandCollapse}
                  expandedCategories={expandedCategories}
                  setTaskToEdit={setTaskToEdit}
                  taskRefs={taskRefs}
                  getTask={getTask}
                  setIsEdit={setIsEdit}
                  taskToEdit={taskToEdit}
                  selectedProperty={selectedProperty?.pa_addressTwo}
                  updateTaskScrollRef={updateTaskScrollRef}
                  highlightKey={highlightKey}
                  combinedData={combinedData}
                  ownercardprop={ownercardprop}
                  address={address}
                />
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      ) : (
        <Card
          container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: '20px',
            width: '865px',
            height: '1171.87px',
            marginTop: '15px',
            backgroundColor: 'rgba(251, 251, 251, 1)',
          }}
        >
          <Grid container>
            <Grid item>
              <Stack
                sx={{ width: '325px', height: '30px' }}
                style={{
                  justifyContent: 'right',
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: '470px',
                }}
              >
                <Grid onClick={onClose} sx={{ cursor: 'pointer' }}>
                  <RightArrow />{' '}
                </Grid>
              </Stack>
            </Grid>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: '0px',
              height: '131px',
              width: '763px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0px',
                gap: '20px',
                width: '432px',
                height: '48px',
              }}
            >
              <Box sx={{ width: '94px', height: '48px' }}>
                <Typography
                  sx={{ ...poppins600, fontSize: '32px', color: '#262626' }}
                >
                  Notes
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  padding: '0px',
                  gap: '15px',
                  width: '318px',
                  height: '30px',
                }}
              >
                <Button
                  variant="outlined"
                  sx={{
                    border: '1px solid #6C2AD2',
                    color: '#6C2AD2',
                    ...poppins400,
                    fontSize: '12px',
                  }}
                >
                  {' '}
                  #Buyer
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    border: '1px solid  #4CA4D6',
                    color: ' #4CA4D6',
                    ...poppins400,
                    fontSize: '12px',
                  }}
                >
                  {' '}
                  #Owner
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    border: '1px solid #666666',
                    color: '#666666',
                    ...poppins400,
                    fontSize: '12px',
                  }}
                >
                  {' '}
                  #Appraisal
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                padding: '0px',
                gap: ' 317px',
                width: '744px',
                height: '83px',
              }}
            >
              <Box>
                <Box
                  sx={{
                    width: '125.37px',
                    height: '54.99px',
                    alignItems: 'center',
                    flexDirection: 'row',
                    display: 'flex',
                  }}
                >
                  <Box>
                    <FeedbackProfile />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '12px',
                        color: '#112347',
                      }}
                    >
                      {' '}
                      Keil Glass
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    padding: '0px',
                    gap: '5px',
                    position: 'relative',
                    width: '260px',
                    height: '40px',
                    marginLeft: '20px',
                  }}
                >
                  <Location />
                  <Typography
                    sx={{ ...poppins300, fontSize: '12px', color: '#112347' }}
                  >
                    {' '}
                    56 Owen Street, North Bondi
                  </Typography>
                  <ArrowDown />
                  <Box
                    sx={{ width: '14px', height: '14px', marginTop: '-12px' }}
                  >
                    <CancelOutlinedIcon />
                  </Box>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  padding: '9px 0px',
                  gap: '15px',
                  width: '75px',
                  height: '48px',
                }}
              >
                <Chat />
                <Phone />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: '15px',
              gap: '15px',
              marginTop: '40px',
              width: '815px',
              height: '334.68px',

              background: '#FFFFFF',
              boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
              bordeRadius: '5px',
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                padding: '0px',
                gap: '15px',

                width: '805px',
                height: '87.68px',
              }}
            >
              <Box>
                <Tabs
                  style={{
                    color: 'purpleHeart',
                    borderBottom: 'purpleheart',
                    display: 'false',
                  }}
                  value={value}
                  onChange={handleChange}
                  aria-label=" tabs example"
                  sx={{
                    '& .MuiTabs-indicator': {
                      backgroundColor: '#fffff',
                      marginBottom: '5px',
                    },
                    '& .MuiTab-root.Mui-selected': {
                      color: '#2F74EE',
                      background: 'rgba(0, 101, 252, 0.1)',
                      width: '67.13px',
                      height: '36.68px',
                      p: '0px',
                    },
                  }}
                >
                  <Tab
                    style={{
                      minHeight: '39.68px',
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: 'row',
                      gap: 4,
                    }}
                    className={classes.tab}
                    label="Notes"
                    icon={<Notetask />}
                    {...a11yProps(0)}
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      textTransform: 'capitalize',
                    }}
                  />

                  <Tab
                    style={{
                      minHeight: '39.68px',
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 4,
                    }}
                    className={classes.tab}
                    label="Task"
                    icon={<TaskList />}
                    {...a11yProps(1)}
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: '12px',
                      textTransform: 'none',
                    }}
                  />
                </Tabs>
                <TabPanel value={value} index={0}></TabPanel>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '0px',
                  gap: '10px',
                  width: '783px',
                  height: '36px',
                }}
              >
                <Box
                  component="form"
                  sx={{
                    p: '2px 4px',
                    display: 'flex',
                    alignItems: 'center',
                    width: '842px',
                    backgroundColor: '##FFFFFF',
                    border: ' 0.5px solid #D9D9D9',
                    borderRadius: '5px',
                    height: '36px',
                  }}
                >
                  <InputBase
                    sx={{
                      ml: 1,
                      flex: 1,
                      '& ::placeholder': {
                        color: '#8B8B8B',
                        fontSize: '14px',
                        fontWeight: 400,
                        fontFamily: 'poppins',
                        opacity: 1,
                      },

                      fontSize: '14px',
                      fontWeight: 400,
                      fontFamily: 'poppins',
                      color: '#8B8B8B',
                    }}
                    placeholder="Search"
                    inputProps={{
                      'aria-label': 'Search here',
                    }}
                  />
                </Box>
                <Box>
                  <Select
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#666666',
                      border: '0.5px solid #D9D9D9',
                      borderRadius: '4px',
                      height: '36px',
                      width: '126px',
                      background: '#FFFFFF',
                      p: '0px',
                    }}
                    size="small"
                    value="10"
                    style={{
                      padding: 'none',
                    }}
                    onChange={() => {}}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        padding: 'none',
                      }}
                    >
                      <span
                        style={{
                          display: 'inline-block',
                          maxWidth: '100%',
                          marginLeft: '-8px',
                        }}
                      >
                        Vendor Report
                      </span>
                    </MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </Box>
              </Box>
            </Grid>
            <Grid item sx={{ marginTop: '6px' }}>
              <TextField
                variant="standard"
                multiline
                rows={5}
                InputProps={{ disableUnderline: true }}
                style={{
                  width: '793px',
                  height: '153px',
                  padding: '0px 0px 10px 5px',
                  fontFamily: 'poppins',
                }}
                placeholder="Details"
                sx={{
                  '& ::placeholder': {
                    color: '#8B8B8B',
                    fontSize: '14px',
                    fontWeight: 400,
                    fontFamily: 'poppins',
                    opacity: 1,
                  },
                  border: '0.5px solid #D9D9D9',
                  borderRadius: '5px',
                  background: '#FFFFFF',
                }}
              />
            </Grid>
            <Grid
              item
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '0px',
                gap: '5px',
                marginLeft: '62px',
                width: '733px',
                height: '34px',
              }}
            >
              <Box>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '12px',
                    lineHeight: '18px',
                    color: '#000000',
                  }}
                >
                  Tags -
                </Typography>
              </Box>
              <Box>
                <Box
                  sx={{
                    width: '69px',
                    height: '17px',

                    background: '#0BC4ED',
                    borderRadius: ' 5px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    padding: '1px 10px',
                  }}
                >
                  <Typography
                    sx={{ color: '#FFFFFF', ...poppins500, fontSize: '10px' }}
                  >
                    #Public
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Button
                  sx={{
                    width: '153px',
                    height: '34px',
                    border: '0.5px solid #D9D9D9',
                    bordeRadius: '5px',
                    minWidth: '153px',
                    p: '0px',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#272727',
                      textTransform: 'none',
                    }}
                  >
                    + Insert Template Text
                  </Typography>
                </Button>
              </Box>
              <Box>
                <Typography style={{ paddingRight: '10px' }}>
                  <Button
                    sx={{
                      width: '86px',
                      ...poppins400,
                      fontSize: '12px',
                      color: '#6C2AD2',
                      height: '35px',
                      background: '#ECE5F6',
                      borderRadius: ' 5px',
                      textTransform: 'none',
                    }}
                  >
                    Add Note
                  </Button>
                </Typography>
              </Box>
            </Grid>
            <Grid item></Grid>
            <Grid item>
              <FeedbackDocumentation OwnerExpanded={true} />
            </Grid>
          </Grid>
        </Card>
      )}
      <TemplateText
        anchorElMessage={anchorElMessage}
        setAnchorElMessage={setAnchorElMessage}
        setDetails={
          schedule
            ? setScheduleDetails
            : value == 0
            ? setNoteDetails
            : setTaskDetails
        }
      />
      <Dialog
        open={schedule}
        aria-labelledby="task-dialog-title"
        fullWidth
        maxWidth={'md'}
        sx={{ marginTop: '90px' }}
      >
        <DialogTitle
          sx={{
            ...poppins300,
            fontWeight: '600',
            fontSize: 24,
            pl: '30px',
            pt: '40px',
          }}
          textAlign={'start'}
          id="task-dialog-title"
        >
          Schedule Follow-up Task
        </DialogTitle>
        <DialogContent>
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'right',
              gap: '10px',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '10px',
                alignItems: 'flex-start',
              }}
            >
              <LocationIcon />
              <Typography
                sx={{
                  ...poppins300,
                  fontSize: '12px',
                }}
              >
                {address}
              </Typography>
              <ArrowDown />
            </Box>
            <Box>
              <CancelOutlinedIcon />
            </Box>
          </Grid>
          <Grid container sx={style}>
            <Grid>
              <Grid xs={12}>
                <Grid
                  xs={12}
                  sm={12}
                  container
                  sx={{
                    display: ' flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Grid xs={12} xl={12}>
                    <TextField
                      sx={{
                        width: '100%',
                        borderRadius: '0px',
                        '&.MuiOutlinedInput-input': {
                          textTransform: 'capitalize',
                        },
                        '& .MuiOutlinedInput-root': {
                          fontFamily: 'poppins',
                        },
                        '& .MuiInputLabel-root': {
                          fontFamily: 'poppins',
                          marginRight: '0px',
                        },
                        '& .MuiFormHelperText-root': {
                          fontFamily: 'poppins',
                          marginLeft: '0px',
                        },
                      }}
                      variant="outlined"
                      placeholder="Subject"
                      value={scheduleSubject}
                      onChange={(e) => {
                        setScheduleSubject(e.target.value);
                        setErrorMessageSch((prev) => ({
                          ...prev,
                          subjectSch: false,
                        }));
                      }}
                      InputLabelProps={{
                        style: {
                          fontFamily: 'poppins',
                          textTransform: 'capitalize',
                        },
                      }}
                      helperText={
                        errorMessagesSch.subjectSch && 'Subject is required.'
                      }
                      error={errorMessagesSch.subjectSch}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={12} sx={{ marginTop: '15px' }}>
                <TextField
                  sx={{
                    width: '100%',
                    borderRadius: '0px',
                    '& .MuiOutlinedInput-root': {
                      fontFamily: 'poppins',
                    },
                    '& .MuiInputLabel-root': {
                      fontFamily: 'poppins',
                    },
                    '& .MuiFormHelperText-root': {
                      fontFamily: 'poppins',
                      marginLeft: '0px',
                    },
                  }}
                  variant="outlined"
                  placeholder="Details"
                  multiline
                  value={scheduleDetails}
                  rows={6}
                  onChange={(e) => {
                    let value = e.target.value;
                    value =
                      value.charAt(0).toUpperCase() +
                      value.slice(1).toLowerCase();
                    setScheduleDetails(value);
                    setErrorMessageSch((prev) => ({
                      ...prev,
                      detailsSch: false,
                    }));
                  }}
                  inputProps={{ style: { fontFamily: 'poppins' } }}
                  helperText={
                    errorMessagesSch.detailsSch && 'Details are required.'
                  }
                  error={errorMessagesSch.detailsSch}
                />
              </Grid>
              <Grid
                xs={12}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  justifyContent: 'space-between',
                  fontFamily: 'poppins',
                  marginTop: '20px',
                }}
              >
                <Stack
                  direction={'row'}
                  spacing={1}
                  alignItems={'center'}
                  component={'span'}
                >
                  <IconButton
                    onClick={(e) => setDatePickerAnchorEl(e.currentTarget)}
                  >
                    <Calendarimg
                      onClick={(e) => {
                        setCalender('schedule');
                        setDatePickerAnchorEl(e.currentTarget);
                      }}
                    />
                  </IconButton>
                  <Typography sx={{ ...poppins300, fontWeight: '500' }}>
                    {' '}
                    {filterDate}
                  </Typography>
                  {errorMessagesSch.dateSch && (
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '12px',
                        color: 'red',
                        paddingLeft: '12px',
                      }}
                    >
                      Date and time is required
                    </Typography>
                  )}
                  {errorMessagesSch.dateRangeSch && (
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontSize: '12px',
                        color: 'red',
                        paddingLeft: '12px',
                      }}
                    >
                      Please select a valid time and date.
                    </Typography>
                  )}
                </Stack>
                <Typography display={'flex'} gap={3}>
                  <Button
                    variant="outlined"
                    sx={{
                      padding: '10px',
                      fontWeight: 500,
                      fontSize: '12px',
                      fontFamily: 'poppins',
                      color: 'black',
                      borderColor: '#D9D9D9',
                    }}
                    onClick={(e) => {
                      setAnchorElMessage(e.currentTarget);
                    }}
                  >
                    + Insert Template Text
                  </Button>
                  <Button
                    variant="outlined"
                    sx={{
                      width: '60px',
                      padding: '8px 15px',
                      fontWeight: 400,
                      borderRadius: '10px',
                      letterSpacing: '1px',
                      fontSize: '12px',
                      background: '#ECE5F6',
                      color: '#6C2AD2',
                      fontFamily: 'poppins',
                      border: 'none',
                      '&:hover': {
                        border: 'none',
                        background: '#e5d0ff',
                      },
                    }}
                    onClick={() => {
                      handleSaveSchClicked();
                    }}
                  >
                    Save
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Popover
        open={datePickerAnchorEl}
        anchorEl={datePickerAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ p: 2 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StaticDateTimePicker
              value={newDateValue}
              onClose={handleCloseDatePIcker}
              onAccept={(newdate) => {
                if (!newdate) return;

                const nowSydney = dayjs().tz('Australia/Sydney');
                const oneHourLater = nowSydney.add(1, 'hour');
                let newDateParsed = dayjs(newdate).tz('Australia/Sydney');

                if (
                  newDateParsed.isSame(nowSydney, 'day') &&
                  newDateParsed.isBefore(oneHourLater)
                ) {
                  newDateParsed = oneHourLater.add(1, 'minute');
                }

                if (newDateParsed.isBefore(oneHourLater)) {
                  setDatePickerAnchorEl(null);
                  if (calender === 'Due') {
                    setErrorMessage((prev) => ({
                      ...prev,
                      dateRange: true,
                    }));
                  }
                  if (calender === 'schedule') {
                    setErrorMessageSch((prev) => ({
                      ...prev,
                      dateRangeSch: true,
                    }));
                  }
                  return;
                }

                setnewDate(newDateParsed);
                getDateValue(newDateParsed);
              }}
              orientation={matchessm ? 'portrait' : 'landscape'}
              disablePast={true}
              minDateTime={
                calender === 'Due' ? oneHourLaterDueDate : twoHourLaterDueDate
              }
              onChange={(newdate) => {
                if (!newdate) return;

                const nowSydney = dayjs().tz('Australia/Sydney');
                const oneHourLater = nowSydney.add(1, 'hour');
                let newDateParsed = dayjs(newdate).tz('Australia/Sydney');

                if (
                  newDateParsed.isSame(nowSydney, 'day') &&
                  newDateParsed.isBefore(oneHourLater)
                ) {
                  newDateParsed = oneHourLater.add(1, 'minute');
                  setnewDate(newDateParsed);
                  getDateValue(newDateParsed);
                } else {
                  setnewDate(newDateParsed);
                }
                if (calender === 'Due') {
                  setErrorMessage((prev) => ({
                    ...prev,
                    dueDate: false,
                    dateRange: false,
                  }));
                }
                if (calender === 'schedule') {
                  setErrorMessageSch((prev) => ({
                    ...prev,
                    dateSch: false,
                    dateRangeSch: false,
                  }));
                }
              }}
            />
          </LocalizationProvider>
        </Box>
      </Popover>
    </div>
  );
};
